const initialState = {
  loading: false,
  submitting: false,
  successful: false,
  drivers: [],
  driver: null,
  vehicles: [],
  vehicle: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_DOCUMENT_DRIVERS': {
      return {
        ...state,
        loading: true,
      }
    }

    case 'GET_DOCUMENT_DRIVERS_COMMIT': {
      return {
        ...state,
        loading: false,
        drivers: action.payload.drivers,
      }
    }

    case 'GET_DOCUMENT_DRIVERS_ROLLBACK': {
      return {
        ...state,
        loading: false,
        drivers: initialState.drivers,
      }
    }

    case 'ADD_DRIVER': {
      return {
        ...state,
        submitting: true,
        successful: false,
      }
    }

    case 'ADD_DRIVER_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'ADD_DRIVER_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    case 'REMOVE_DOCUMENT_DRIVER': {
      return {
        ...state,
        submitting: true,
        successful: false,
      }
    }

    case 'REMOVE_DOCUMENT_DRIVER_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'REMOVE_DOCUMENT_DRIVER_ROLLBACK': {
      return {
        ...state,
        successful: false,
        submitting: false,
      }
    }

    case 'SET_DOCUMENT_DRIVER': {
      return {
        ...state,
        driver: action.payload.driver,
      }
    }

    case 'GET_DOCUMENT_VEHICLES': {
      return {
        ...state,
        loading: true,
      }
    }

    case 'GET_DOCUMENT_VEHICLES_COMMIT': {
      return {
        ...state,
        loading: false,
        vehicles: action.payload.vehicles,
      }
    }

    case 'GET_DOCUMENT_VEHICLES_ROLLBACK': {
      return {
        ...state,
        loading: false,
        vehicles: [],
      }
    }

    case 'ADD_VEHICLE': {
      return {
        ...state,
        submitting: true,
        successful: false,
      }
    }

    case 'ADD_VEHICLE_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'ADD_VEHICLE_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    case 'REMOVE_DOCUMENT_VEHICLE': {
      return {
        ...state,
        successful: false,
        submitting: true,
      }
    }

    case 'REMOVE_DOCUMENT_VEHICLE_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'REMOVE_DOCUMENT_VEHICLE_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    case 'SET_DOCUMENT_VEHICLE': {
      return {
        ...state,
        vehicle: action.payload.vehicle,
      }
    }

    default: {
      return state
    }
  }
}
